import { render, staticRenderFns } from "./ProcedureDialog.vue?vue&type=template&id=7994f450"
import script from "./ProcedureDialog.vue?vue&type=script&lang=ts"
export * from "./ProcedureDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports